import { toast } from 'react-toastify';
import { i18n } from '../../translate/i18n';

class OfficialApiOnboardingSessionUtils {
  //  ****************
  //  ** Properties **
  //  ****************
  static ORIGIN = 'https://whatsapp.fxsistemas.com.br';
  static #PATHNAME = 'onboarding-session';

  //  *************
  //  ** Methods **
  //  *************
  static buildPopUp(clientApplicationUuid, token, whatsappId) {
    const fullUrl = `${this.ORIGIN}/${this.#PATHNAME}?token=${encodeURIComponent(token)}&client-application-uuid=${encodeURIComponent(clientApplicationUuid)}&opener-origin=${encodeURIComponent(window.location.origin)}&whatsApp-id=${encodeURIComponent(whatsappId)}`;
    const popup = window.open(fullUrl, '_blank', 'width=500, height=500,resizable=yes,scrollbars=yes');

    if (!popup) {
      toast.warning(i18n.t('popup.notCreated'));
      return;
    }

    return new Promise(resolve => {
      const interval = setInterval(() => {
        if (popup.closed) {
          clearInterval(interval);
          resolve();
        }
      }, 500);
    });
  }
}

export default OfficialApiOnboardingSessionUtils;
